import { createContext, useContext } from 'react';

import type { IMentionFriend } from '@/components/chat-app/components/userInput/SelectMentionModal/type';
import type { IAIPlay, IParticipant } from '@/service/agent';
import type { IHomepageData } from '@/service/homePage';

// Bubble Modal 配置类型
export interface IBubbleModalConfig {
  bubbleId: string;
  bubbleType: IAIPlay['bubbleType'];
  instruction: string;
  type: 'topic' | 'snap' | 'chorus';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  title: string;
}

export type PlayModalType = 'snap' | 'chorus' | 'topic';

export interface PlayModalConfig {
  type: PlayModalType;
  origin?: 'homepage' | 'circle';
  instruction?: string;
  originCreator?: IParticipant[] | null;
  originChoose?: IMentionFriend | null;
  canSelectMention?: boolean;
  bubbleData?: IAIPlay;
}

// 创建一个上下文对象类型

interface HomepageContextType {
  homepageData: IHomepageData | null;
  setHomepageData: (
    data: IHomepageData | null | ((prev: IHomepageData | null) => IHomepageData | null)
  ) => void;
  refreshHomepageData: () => void;
  // Bubble 相关
  bubbleData: IAIPlay | null;
  setBubbleData: (data: IAIPlay | null | ((prev: IAIPlay | null) => IAIPlay | null)) => void;
  bubbleLoading: boolean;
  setBubbleLoading: (loading: boolean) => void;
  fetchBubble: (forceRefresh?: boolean) => void;
  playModalOpen: boolean;
  setPlayModalOpen: (data: boolean) => void;
  modalConfig: PlayModalConfig | undefined;
  setModalConfig: (data: PlayModalConfig | undefined) => void;
}

// 创建一个默认值为空对象的上下文

const HomepageContext = createContext<HomepageContextType>({
  homepageData: null,
  setHomepageData: () => {},
  refreshHomepageData: () => {},
  // Bubble 相关默认值
  bubbleData: null,
  setBubbleData: () => {},
  bubbleLoading: false,
  setBubbleLoading: () => {},
  fetchBubble: () => {},
  // PlayModal
  playModalOpen: false,
  setPlayModalOpen: () => {},
  modalConfig: undefined,
  setModalConfig: () => {}
});

// 创建一个自定义的Hook来使用这个上下文

export const useHomepageContext = () => useContext(HomepageContext);

// 导出上下文对象

export default HomepageContext;
